import { useEffect, useState } from 'react'

export const useExtensionSidePanel = (shadowDom: HTMLElement | null) => {
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false)
  const [hasSidePanelBeenOpened, setHasSidePanelBeenOpened] = useState(false)

  // Set initial state based on shadow DOM
  useEffect(() => {
    if (!shadowDom) return

    const extensionNotchContainer = shadowDom.shadowRoot?.querySelector(
      'div[data-testid=assistant-notch-container]',
    )
    setIsSidePanelOpen(!extensionNotchContainer)
  }, [shadowDom])

  // Observe changes in shadow DOM to update side panel state
  useEffect(() => {
    if (!shadowDom) return

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (
              node instanceof HTMLElement &&
              node.querySelector('div[data-testid=assistant-notch-container]')
            ) {
              setIsSidePanelOpen(false)
              return
            }
          }
          for (const node of mutation.removedNodes) {
            if (
              node instanceof HTMLElement &&
              node.querySelector('div[data-testid=assistant-notch-container]')
            ) {
              setIsSidePanelOpen(true)
              return
            }
          }
        }
      }
    })

    observer.observe(shadowDom.shadowRoot!, { childList: true })

    return () => {
      observer.disconnect()
    }
  }, [shadowDom])

  // Track if side panel has ever been opened
  useEffect(() => {
    if (isSidePanelOpen && !hasSidePanelBeenOpened) {
      setHasSidePanelBeenOpened(true)
    }
  }, [isSidePanelOpen, hasSidePanelBeenOpened])

  return { isSidePanelOpen, hasSidePanelBeenOpened }
}
